import React, {useCallback} from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Divider from '@material-ui/core/Divider';
import {makeStyles} from '@material-ui/core/styles';

import {Job, JobId, ModifyJobRequest} from '@store/@types/kpi';

import {Form} from '@components/form/Form';
import Grid from '@material-ui/core/Grid';
import {ClosableDialogTitle} from '@components/dialog/closable-title/ClosableDialogTitle';
import {LabelInput} from '@components/label-input/LabelInput';

interface JobFormProps {
  open: boolean;
  onClose: () => void;
  job?: Job;
  onSubmit: (newJob: ModifyJobRequest, jobId?: JobId) => Promise<void>;
}

export const JobForm: React.FC<JobFormProps> = ({onSubmit, job, open, onClose}) => {
  const handleSubmit = useCallback(
    values => {
      onSubmit(values, job?.id).then(onClose).catch(console.error);
    },
    [job, onClose, onSubmit]
  );

  const {content} = useStyles();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <Form onSubmit={handleSubmit}>
        <ClosableDialogTitle onClose={onClose}>
          {job ? 'Edit Job' : 'Create Job'}
        </ClosableDialogTitle>
        <Divider />
        <DialogContent className={content}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <LabelInput autoFocus defaultValue={job?.name} name="name" label="Job title" />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type="submit" color="primary" variant="contained">
            {job ? 'Save Job' : 'Create Job'}
          </Button>
          <Button variant="contained" onClick={onClose}>
            Cancel
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  );
};

const useStyles = makeStyles(theme => ({
  content: {
    width: 400,
    padding: theme.spacing(3, 3.25, 3, 3),
  },
}));
